module.exports = __webpack_public_path__ + "img/item1.83216d09.png";